import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';

// Router à la main mais je n'avais pas le temps

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
		meta: {
			title: 'Home',
		},
	},
	{
		path: '/about',
		name: 'About',
		// séparation du code au niveau de la route
		// cela génère un morceau séparé (projects.[hash].js) pour cette route
		// qui est chargé paresseusement lorsque la route est visitée.
		component: () =>
			import(/* webpackChunkName: "about" */ '../views/About.vue'),
		meta: {
			title: 'About',
		},
	},
	{
		path: '/contact',
		name: 'Contact',
		// séparation du code au niveau de la route
		// cela génère un morceau séparé (projects.[hash].js) pour cette route
		// qui est chargé paresseusement lorsque la route est visitée.
		component: () =>
			import(/* webpackChunkName: "projects" */ '../views/Contact.vue'),
		meta: {
			title: 'Contact',
		},
	},
	{
		path: '/projects',
		name: 'Projects',
		// séparation du code au niveau de la route
		// cela génère un morceau séparé (projects.[hash].js) pour cette route
		// qui est chargé paresseusement lorsque la route est visitée.
		component: () =>
			import(/* webpackChunkName: "projects" */ '../views/Projects.vue'),
		meta: {
			title: 'Projects',
		},
	},
	{
		path: '/projects/NewEra',
		name: 'New Era Festival',
		// séparation du code au niveau de la route
		// cela génère un morceau séparé (projects.[hash].js) pour cette route
		// qui est chargé paresseusement lorsque la route est visitée.
		component: () =>
			import(
				/* webpackChunkName: "projects" */ '../views/Projects/NewEraFestival.vue'
			),
		meta: {
			title: 'New Era Festival',
		},
	},
	{
		path: '/projects/Onboarding',
		name: 'Onboarding',
		// séparation du code au niveau de la route
		// cela génère un morceau séparé (projects.[hash].js) pour cette route
		// qui est chargé paresseusement lorsque la route est visitée.
		component: () =>
			import(
				/* webpackChunkName: "projects" */ '../views/Projects/Onboarding.vue'
				),
		meta: {
			title: 'UniVR Studio Onboarding',
		},
	},
	{
		path: '/projects/Bloom',
		name: 'Bloom',
		// séparation du code au niveau de la route
		// cela génère un morceau séparé (projects.[hash].js) pour cette route
		// qui est chargé paresseusement lorsque la route est visitée.
		component: () =>
			import(
				/* webpackChunkName: "projects" */ '../views/Projects/Bloom.vue'
				),
		meta: {
			title: 'UniVR Studio CRM',
		},
	},
	{
		path: '/projects/Parcoursup',
		name: 'Parcoursup',
		// séparation du code au niveau de la route
		// cela génère un morceau séparé (projects.[hash].js) pour cette route
		// qui est chargé paresseusement lorsque la route est visitée.
		component: () =>
			import(
				/* webpackChunkName: "projects" */ '../views/Projects/Parcoursup.vue'
				),
		meta: {
			title: 'Parcoursup',
		},
	},
	{
		path: '/projects/DailyAthlon',
		name: 'DailyAthlon',
		// séparation du code au niveau de la route
		// cela génère un morceau séparé (projects.[hash].js) pour cette route
		// qui est chargé paresseusement lorsque la route est visitée.
		component: () =>
			import(
				/* webpackChunkName: "projects" */ '../views/Projects/DailyAthlon.vue'
				),
		meta: {
			title: 'DailyAthlon',
		},
	},
	{
		path: '/projects/Rescue',
		name: 'RESCUE',
		// séparation du code au niveau de la route
		// cela génère un morceau séparé (projects.[hash].js) pour cette route
		// qui est chargé paresseusement lorsque la route est visitée.
		component: () =>
			import(
				/* webpackChunkName: "projects" */ '../views/Projects/Rescue.vue'
				),
		meta: {
			title: 'Rescue',
		},
	},
	{
		path: '/projects/Ocaly',
		name: 'Rescue',
		// séparation du code au niveau de la route
		// cela génère un morceau séparé (projects.[hash].js) pour cette route
		// qui est chargé paresseusement lorsque la route est visitée.
		component: () =>
			import(
				/* webpackChunkName: "projects" */ '../views/Projects/Ocaly.vue'
				),
		meta: {
			title: 'Ocaly',
		},
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	scrollBehavior() {
		document.getElementById('app').scrollIntoView();
	},
});

export default router;

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
	// This goes through the matched routes from last to first, finding the closest route with a title.
	// e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
	// `/nested`'s will be chosen.
	const nearestWithTitle = to.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.title);

	// Find the nearest route element with meta tags.
	const nearestWithMeta = to.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.metaTags);

	const previousNearestWithMeta = from.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.metaTags);

	// If a route with a title was found, set the document (page) title to that value.
	if (nearestWithTitle) {
		document.title = nearestWithTitle.meta.title;
	} else if (previousNearestWithMeta) {
		document.title = previousNearestWithMeta.meta.title;
	}

	// Remove any stale meta tags from the document using the key attribute we set below.
	Array.from(
		document.querySelectorAll('[data-vue-router-controlled]')
	).map((el) => el.parentNode.removeChild(el));

	// Skip rendering meta tags if there are none.
	if (!nearestWithMeta) return next();

	// Turn the meta tag definitions into actual elements in the head.
	nearestWithMeta.meta.metaTags
		.map((tagDef) => {
			const tag = document.createElement('meta');

			Object.keys(tagDef).forEach((key) => {
				tag.setAttribute(key, tagDef[key]);
			});

			// We use this to track which meta tags we create so we don't interfere with other ones.
			tag.setAttribute('data-vue-router-controlled', '');

			return tag;
		})
		// Add the meta tags to the document head.
		.forEach((tag) => document.head.appendChild(tag));

	next();
});
